export default {
    environment: 'debug',     //debug or online
    api: {
        url: 'https://api.graduatedart.com',
        websocket: 'ws://10.1.2.8:18282'
    }
}


// WEBPACK FOOTER //
// ./.config.js